import { lazy } from "react";

const routes = [
  {
    path: "/future_fulfillment",
    element: lazy(() => import("../pages/FutureFulfillment")),
  },
  {
    path: "/enquiryItems/:enquiryId",
    element: lazy(() => import("../pages/FutureFulfillment/EnquiryItem")),
  },
  {
    path: "/punchEnquiryOrder/:enquiryId",
    element: lazy(() => import("../pages/FutureFulfillment/PunchOrder")),
  },
];

export default routes;
